import {IFrame, RowIndex} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FieldRef} from '@mintdata/mint-kit/impl/frames/FieldRef';
import {RowFilterKind} from '@mintdata/mint-kit/impl/frames/RowFilterKind';

export type FrameSelectExpr = string;
export type RowFilterExpr = string;

export class FrameSelectionError extends Error
{
}

export class FrameSelectionParseState
{
    public static readonly First = 'first';
    public static readonly Last = 'last';
    public static readonly N = 'N';
    public static readonly Lowercase_N = 'n';
    public static readonly Random = 'random';

    constructor(public availableFieldRefs:Array<FieldRef> = [],
                public fieldRefs:Array<FieldRef> = [],
                public rowIndexExpr:string = null,
                public rowRangeFromExpr:string = null,
                public rowRangeToExpr:string = null,
                public rowFilterExpr:string = null,)
    {
    }

    public get hasRowFilter():boolean
    {
        return this.rowIndexExpr !== null ||
            this.rowRangeFromExpr !== null ||
            this.rowRangeToExpr !== null ||
            this.rowFilterExpr !== null;
    }
}

export class RowFilterResult
{
    constructor(public readonly frame:IFrame,
                public readonly rowFilterKind:RowFilterKind,
                public readonly firstRowIndex:RowIndex,
                public readonly lastRowIndex:RowIndex,
                public readonly rowIndices:Array<RowIndex> = null)
    {
    }
}
